'use strict';
let map, marker, phone_rx, email_rx, gal_c, gal_t;
const init = (eAI) => {
	phone_rx = new RegExp('^[0-9\-\+ ]{8,15}$');
	email_rx = new RegExp('^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$');
	getScript( 'https://maps.googleapis.com/maps/api/js?key=AIzaSyALUjS_TC_VAhVXQaayjv_KsOhVlWZwOAo&', function() {
        map = new google.maps.Map(document.getElementById('map'), {
			center: {lat: 9.968, lng: -84.406683},
			zoom: 14,
			styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
		});
		marker = new google.maps.Marker({
			position: {lat: 9.965752, lng: -84.406683},
			map: map,
			title: 'Vista Atenas 54',
			//icon: ''
		});
		//console.log(map);
	});
	document.querySelector('.main-menu-toggler').addEventListener('click', toggleMenu, !1);
	document.querySelector('form').addEventListener('submit', formProcess, !1);
	addEventListenerList(document.querySelectorAll('.amenities-imgs img'), 'mouseover', hoverAmenities);
	addEventListenerList(document.querySelectorAll('.amenities-imgs img'), 'mouseout', outAmenities);
	addEventListenerList(document.querySelectorAll('.gallery-loop a'), 'click', clickGallery);
};
const formProcess = (eFC) => {
	eFC.preventDefault();
	let _m = '';

	if( document.querySelector('#name_txt').value == '' ) {
		_m += '<li>El <strong>"Nombre"</strong> no puede estar vacío.</li>';
	}
	if( !email_rx.test(document.querySelector('#email_txt').value) ) {
		_m += '<li>El <strong>"Correo Electrónico"</strong> debe tener el formato correcto.</li>';
	}
	if( !phone_rx.test(document.querySelector('#phone_txt').value) ) {
		_m += '<li>El <strong>"Teléfono"</strong> debe tener el formato correcto.</li>';
	}
	if( document.querySelector('#msj_txt').value == '' ) {
		_m += '<li>El <strong>"Mensaje"</strong> no puede estar vacío.</li>';
	}

	if( _m != '' ) {
		appendModal(`<p>Debe solucionar lo siguiente:</p><ul>${_m}</ul>`,'Atención');
	} else {
		appendPreloader('Procesando datos ...');
		postAjax('/api/', {
			f: Date.now(),
			name_txt: document.querySelector('#name_txt').value,
			phone_txt: document.querySelector('#phone_txt').value,
			email_txt: document.querySelector('#email_txt').value,
			msj_txt: document.querySelector('#msj_txt').value
		}, transferComplete);
	}
};
const transferComplete = (eTC) => {
	//data_json = JSON.parse(eTC);
	let tit_modal, msj_modal;
	removePreloader();
	document.querySelector('#name_txt').value = '';
	document.querySelector('#phone_txt').value = '';
	document.querySelector('#email_txt').value = '';
	document.querySelector('#msj_txt').value = '';
	switch( document.getElementsByTagName('html')[0].getAttribute("lang") ) {
		case 'en':
			tit_modal = 'Done';
			msj_modal = 'Your message has been sent.';
			break;
		default:
			tit_modal = 'Listo';
			msj_modal = 'Su mensaje ha sido enviado.';
			break;
	}
	appendModal( msj_modal, tit_modal );
};
const clickGallery = (eCG) => {
	eCG.preventDefault();
	gal_c = parseInt(eCG.target.parentNode.getAttribute('href').replace('.jpg','').replace('/img/g/b/va54-',''));
	gal_t = document.querySelector('.gallery-loop').childElementCount;
	openGallery();
};
const openGallery = () => {
	let imgMdlGal = createCustomElement('img',{'src': '/img/g/b/va54-'+addZero(gal_c)+'.jpg', 'alt':'', 'class':'img-fluid'});
	let imgCont = createCustomElement('div',{'class':'main-img-cont'},[
		imgMdlGal,
		createCustomElement('div',{'id':'back_g_btn'},['«']),
		createCustomElement('div',{'id':'next_g_btn'},['»'])
	]);
	appendModal( imgCont, undefined, '', true );
	document.getElementById('back_g_btn').addEventListener('click',navGal,!1);
	document.getElementById('next_g_btn').addEventListener('click',navGal,!1);
};
const navGal = (eNG) => {
	//console.log(eNG.target.getAttribute('id'))
	removeModal();
	let _cAtt = eNG.target.getAttribute('id');
	gal_t = document.querySelector('.gallery-loop').childElementCount;
	if( gal_c == 1 && _cAtt == 'back_g_btn' ) {
		gal_c = gal_t;
	} else if( gal_c == gal_t && _cAtt == 'next_g_btn' ) {
		gal_c = 1;
	} else {
		if( _cAtt == 'next_g_btn' ) {
			gal_c++;
		} else {
			gal_c--;
		}
	}
	openGallery();
};
const toggleMenu = (eTM) => {
	eTM.preventDefault();
	document.querySelector('.main-menu ul').classList.toggle('open-menu');
};
const outAmenities = (eOA) => {
	document.querySelector('.amenities-desc').classList.remove('ani-amenities-desc');
	document.querySelector('.amenities-desc').innerHTML = '';
}
const hoverAmenities = (eHA) => {
	document.querySelector('.amenities-desc').classList.remove('ani-amenities-desc');
	document.querySelector('.amenities-desc').innerHTML = eHA.srcElement.getAttribute('alt');
	document.querySelector('.amenities-desc').classList.add('ani-amenities-desc');
};
const addZero = (numStr) => {
	let ntr = numStr.toString();
	if(ntr.length == 1) {
		ntr = '0'+ntr;
	}
	return ntr;
};
const getScript = (source, callback) => {
	var script = document.createElement('script');
	var prior = document.getElementsByTagName('script')[0];
	script.async = 1;

	script.onload = script.onreadystatechange = function( _, isAbort ) {
		if(isAbort || !script.readyState || /loaded|complete/.test(script.readyState) ) {
			script.onload = script.onreadystatechange = null;
			script = undefined;

			if(!isAbort) { if(callback) callback(); }
		}
	};

	script.src = source;
	prior.parentNode.insertBefore(script, prior);
};
const addEventListenerList = (list, event, fn) => {
    for (var i = 0, len = list.length; i < len; i++) {
        list[i].addEventListener(event, fn, !1);
    }
};
const appendPreloader = (pl_txt) => {
	let pldiv = createCustomElement('div',{},[
		createCustomElement('div',{'class':'spinner_mc'}),
		createCustomElement('div',{'class':'status_sp_txt'},[pl_txt])
	]);
	let overall = createCustomElement('div',{'class':'modal-pl'},[pldiv]);
	document.body.style.overflow = 'hidden';
	document.body.appendChild(overall);
}
const removePreloader = (eRP) => {
	if(eRP) {
		eRP.preventDefault();
	}
	document.body.style.overflow = 'visible';
	document.body.removeChild(document.querySelector('.modal-pl'));
}
const appendModal = (modalTxt, modalTittle, modalFooter, modalGallery = false) => {
	let modCont = new Array();
	if(modalTittle != undefined) {
		modCont.push( createCustomElement('div',{'class':'modal_header'},[ createCustomElement('h3',{},[modalTittle]) ]) );
	}
	modCont.push( createCustomElement('div',{'class':'modal_body'},[modalTxt]) );
	if(modalFooter != undefined) {
		modCont.push( createCustomElement('div',{'class':'modal_footer'},[modalFooter]) );
	}
	modCont.push( createCustomElement('a',{'href':'#','class':'modal_close'},['×']) );
	let mdl = createCustomElement('div',{'class':'modalAll'},modCont);
	let blk = createCustomElement('div',{'id':'modalDialog'},[mdl]);
	if( modalGallery ) {
		blk.className += 'modal-gallery';
	}
	blk.addEventListener('click', e => {
		if(e.target === blk) {
			removeModal();
		}
	});
	document.body.style.overflow = 'hidden';
	document.body.appendChild(blk);
	document.querySelector('.modal_close').addEventListener('click',removeModal);
}
const removeModal = (eRM) => {
	if(eRM) {
		eRM.preventDefault();
	}
	document.body.style.overflow = 'visible';
	document.body.removeChild(document.getElementById('modalDialog'));
}
// https://github.com/escueladigital/EDui
// Crear elementos con atributos e hijo
const createCustomElement = (element,attributes,children) => {
	let customElement = document.createElement(element);
	if (children !== undefined) children.forEach(el => {
		if (el.nodeType) {
			if (el.nodeType === 1 || el.nodeType === 11) customElement.appendChild(el);
		} else {
			customElement.innerHTML += el;
		}
	});
	addAttributes(customElement,attributes);
	return customElement;
};

// Añadir un objeto de atributos a un elemento
const addAttributes = (element, attrObj) => {
	for (let attr in attrObj) {
		if (attrObj.hasOwnProperty(attr)) {
			element.setAttribute(attr,attrObj[attr]);
		}
	}
};

// https://plainjs.com/javascript/ajax/send-ajax-get-and-post-requests-47/
const postAjax = (url, data, success) => {
	var params = typeof data == 'string' ? data : Object.keys(data).map(
			function(k){ return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
		).join('&');

	var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
	xhr.open('POST', url);
	xhr.onreadystatechange = function() {
		if (xhr.readyState>3 && xhr.status==200) { success(xhr.responseText); }
	};
	xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	xhr.send(params);
	return xhr;
}
document.addEventListener('DOMContentLoaded', init, !1);
